<template>
  <div>
    <transition name="modal">
      <information-modal
        v-if="showInfoModal"
        :message="info"
        @close="showInfoModal = false"
      ></information-modal>
    </transition>

    <div class="flex items-center space-x-4">
      <h2>{{ isEditing ? "Editar" : "Agregar" }} Comentario</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form class="flex flex-col w-full" @submit.prevent="save">
        <div class="flex flex-col w-full">
          <label for="commenter">¿Quién hace el comentario?</label>
          <input id="commenter" v-model="form.commenter" />
          <validation-errors
            :errors="errorFor('commenter')"
          ></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="comment">Comentarios</label>
          <textarea
            class="h-28"
            id="comment"
            type="text"
            v-model="form.comment"
          />
          <validation-errors :errors="errorFor('comment')"></validation-errors>
        </div>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Agregar" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import deleteMixin from "@/mixins/deleteMixin";
import { is422 } from "@/utils/response";
export default {
  name: "Comment Form",

  data() {
    return {
      form: {
        commenter: null,
        comment: null,
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "pets");

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadComment();
    }
  },

  mixins: [validationErrors, deleteMixin],

  methods: {
    async loadComment() {
      this.loading = true;

      try {
        let response = await api.pets.getCommentById(this.$route.params.id);

        this.form = await JSON.parse(JSON.stringify(response));
      } catch (error) {
        console.log(error);
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createComment();
      } else {
        this.updateComment();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.commenter) {
        this.errors["commenter"] = ["Campo requerido"];
      }

      if (!this.form.comment) {
        this.errors["comment"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createComment() {
      this.loadingForm = true;

      try {
        const response = await api.pets.createComment(
          this.$route.params.petId,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "petsDetail", params: { id: this.$route.params.petId } });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateComment() {
      this.loadingForm = true;

      try {
        const response = await api.pets.updateComment(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "petsIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>
